import React, { useCallback, useEffect } from "react";
import DadosProfissionaisSantanderForm from "./DadosProfissionaisSantanderForm";
import { useDispatch, useSelector } from "react-redux";
import {
  getPreenchimentoOperacao,
  isGravandoPreenchimentoOperacao,
} from "../../../../selectors/operacao.selectors";
import useCompleteForm from "../../../../hooks/useCompleteForm";
import validators from "../../../../utils/validators";
import { actions } from "../../../../actions/operacao.actions";
import { transformToDate } from "../../../../utils/basic";
import formatters from "../../../../utils/formatters";

const DadosProfissionaisSantanderFormConnected = ({
  handleGoTo4,
  eventsNaoCorrentista,
  setComprador,
  comprador,
  ...props
}) => {
  const dispatch = useDispatch();
  const {
    operacao,
    dominios: { perfilRenda: perfisRenda, profissao: profissoes },
  } = useSelector(getPreenchimentoOperacao);
  const submitting = useSelector(isGravandoPreenchimentoOperacao);

  const resetValues = useCallback(
    () => ({
      renda: "",
      perfilRenda: null,
      ...comprador,
      dadosProfissionais: {
        profissao: null,
        nomeEmpresa: "",
        dataAdmissao: "",
        cargo: "",
        ...comprador?.dadosProfissionais,
      },
    }),
    [comprador]
  );

  const callback = useCallback(
    (data) => {
      const c = data.operacao.participantes.find((p) => p.id === comprador.id);
      if (!!c) {
        setComprador({
          ...c,
          fluxo: data.validacao[
            data.operacao.detalhe.correntista ? "correntista" : "completa"
          ]?.participantes?.find((f) => f.id === c?.id)?.etapas,
        });
      }
      handleGoTo4();
    },
    [handleGoTo4, setComprador, comprador]
  );

  const [formProps, handleSubmit] = useCompleteForm({
    rules: () => ({
      renda: validators.number({ required: true }),
      perfilRenda: validators.object({ required: true }),
      dadosProfissionais: {
        profissao: validators.object({ required: true }),
        nomeEmpresa: validators.string({ required: true }),
        dataAdmissao: validators.date({
          required: true,
          min: "01/01/1900",
          max: formatters.dates.short(new Date()),
        }),
        cargo: validators.string({ required: true }),
      },
    }),
    initialValues: resetValues,
    handleSubmit: useCallback(
      (values) => {
        dispatch(
          actions.gravarPreenchimento.request({
            callback,
            instituicao: operacao.codigoInstituicao,
            passo: "dados-profissionais",
            participante: {
              id: comprador?.id,
              renda: values?.renda,
              idPerfilRenda: values.perfilRenda?.id,
              dadosProfissionais: {
                idProfissao: values.dadosProfissionais.profissao?.id,
                nomeEmpresa: values.dadosProfissionais.nomeEmpresa,
                dataAdmissao: transformToDate(
                  values.dadosProfissionais.dataAdmissao
                ),
                cargo: values.dadosProfissionais.cargo,
              },
            },
            operacao: {
              id: operacao.id,
            },
          })
        );
      },
      [callback, comprador, operacao, dispatch]
    ),
  });

  const { reset } = formProps;

  useEffect(() => {
    reset(resetValues());
  }, [perfisRenda, comprador, resetValues, reset]);

  return (
    <DadosProfissionaisSantanderForm
      {...props}
      perfisRenda={perfisRenda}
      profissoes={profissoes}
      fluxo={comprador.fluxo}
      events={eventsNaoCorrentista}
      formProps={formProps}
      handleSubmit={handleSubmit}
      submitting={submitting}
    />
  );
};

export default DadosProfissionaisSantanderFormConnected;
